import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';

interface MobileStickyCTAProps {
  /** Show only on landing page (not inside app) */
  landingOnly?: boolean;
}

export function MobileStickyCTA({ landingOnly = true }: MobileStickyCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) return;

    const handleScroll = () => {
      // Show after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  // Only show on mobile
  if (!isMobile) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 pb-safe bg-background/95 backdrop-blur-xl border-t border-border/50 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]"
        >
          <Button
            size="lg"
            className="w-full h-14 min-h-[56px] text-base font-bold rounded-xl shadow-lg shadow-primary/25 bg-primary hover:bg-primary/90 transition-all active:scale-[0.98]"
            onClick={() => navigate('/register')}
          >
            <Sparkles className="mr-2 w-5 h-5" />
            Testar Grátis — 7 dias
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
          
          {/* Trust micro-copy */}
          <p className="text-center text-xs text-muted-foreground mt-2">
            Sem cartão • Cancele quando quiser
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
